// #genai Phase 2 remove-payment-method confirmation modal — pixel-matched to Figma 730:30547
// (desktop, 450px) and 269:20479 (mobile, 342px). Title renders on two lines: "Remove {methodLabel}"
// then "Ending in {lastFour}?" (the i18n string carries the \n; the title style uses pre-line).
// Body: "This action cannot be undone."  Cancel dismisses; "Yes, Remove" confirms (parent performs
// the optimistic removal).
import React from 'lib/react';
import PropTypes from 'prop-types';
import { useTranslation } from 'lib/translation';
import {
  EVButton,
  EVDialog,
  EVDialogActions,
  EVDialogContent,
  EVDialogContentText,
  EVDialogTitle,
} from 'lib/components';
import RemovePaymentMethodDialogStyles from './RemovePaymentMethodDialogStyles';

function RemovePaymentMethodDialog({
  open, methodLabel, lastFour, onCancel, onConfirm,
}) {
  const { t } = useTranslation();
  const classes = RemovePaymentMethodDialogStyles();

  return (
    <EVDialog open={open} onClose={onCancel} classes={{ paper: classes.dialog }}>
      <EVDialogTitle disableTypography className={classes.title}>
        {t('billing_information__remove_pm_title', { label: methodLabel, lastFour })}
      </EVDialogTitle>
      <EVDialogContent className={classes.content}>
        <EVDialogContentText className={classes.message}>
          {t('billing_information__remove_pm_message')}
        </EVDialogContentText>
      </EVDialogContent>
      <EVDialogActions className={classes.actions}>
        <EVButton
          id="remove-payment-method-cancel-btn"
          variant="outlined"
          className={classes.cancelButton}
          onClick={onCancel}
        >
          {t('billing_information__remove_pm_cancel')}
        </EVButton>
        <EVButton
          id="remove-payment-method-confirm-btn"
          variant="contained"
          className={classes.confirmButton}
          onClick={onConfirm}
        >
          {t('billing_information__remove_pm_confirm')}
        </EVButton>
      </EVDialogActions>
    </EVDialog>
  );
}

RemovePaymentMethodDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  methodLabel: PropTypes.string,
  lastFour: PropTypes.string,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

RemovePaymentMethodDialog.defaultProps = {
  methodLabel: '',
  lastFour: '',
};

export default RemovePaymentMethodDialog;
